export default __webpack_public_path__ + "static/media/epi-chainsaw.22633dc9.png";